import { Foundation } from '@models';

export interface NonMemberFoundationsResult {
  nonMemberFoundations: Foundation[];
}
